import EffectiveDateView from 'text!../views/effective-date.html';
import EffectiveDateCtrl from '../../common/controllers/EffectiveDateCtrl';

export default (function () {

    var wizardParentState = 'baseTransactionWizard';

    return {
        'effectiveDate-bop': {
            name: 'effectiveDate-bop',
            parent: wizardParentState,
            controller: EffectiveDateCtrl,
            template: EffectiveDateView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/quoteandbind/bop/config/RouteConfig.js
// module id = 1778
// module chunks = 0